import React from "react";
import UserDashboard from "../UserDashboard/UserDashboard";

// Odprawy tranzytowe - ten sam widok co dashboard, z danymi aktualnego tranzytu.
const Tranzyt = () => <UserDashboard view="tranzyt" />;

export default Tranzyt;
